<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">Add External Link</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small @click="closePanel" color="primary">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.title"
              v-model="link.title"
              label="Title"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter link title here</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-textarea
              v-model="link.description"
              label="Description"
              hint="Enter a description for this link"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter a description for this link</span>
              </v-tooltip>
            </template>
            </v-textarea>
            <v-text-field
              :error-messages="messages.url"
              v-model="link.url"
              label="URL"
              hint="Enter the URL"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter the URL</span>
              </v-tooltip>
            </template>
            </v-text-field>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex text-right>
        <v-btn v-if="!loading" :color="$store.getters.partner ? 'primary': 'grey300'" @click="closePanel">Cancel</v-btn>&nbsp;
        <v-btn v-if="loading" color="primary" class="ml-2" loading></v-btn>
        <v-btn v-else :color="$store.getters.partner ? 'primary': 'dark-blue'" :class="['ml-2', $store.getters.partner ? '' : 'add-course-button']" @click="addDocument">Add External Link</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
export default {
  name: "AddExternalLink",
  components: {
  },
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    link: {},
    messages: {},
    loading: false,
    successMessage: "External Link Successfully Added.",
    errorMessage:
      "Oops, something went wrong! Please check information is correct.",
  }),
  mounted() {
    this.link.courseId = this.id;
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addDocument() {
      this.loading = true;
      courseAPI
        .addExternalLink(this.link)
        .then(resp => {
          this.closePanel();
          EventBus.$emit("ASSET_ADDED", resp);
          this.$store.dispatch("addCourseMaterials", resp.data.data);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
